exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message_layer[data-v-7dbddb30]{position:fixed;width:100%;height:100%;line-height:100%;display:table;background:rgba(1,1,1,.1);z-index:100000;top:0;left:0}.message_layer>.message_box[data-v-7dbddb30]{display:table-cell;text-align:center;vertical-align:middle;padding:1rem}.message_layer>.message_box>span[data-v-7dbddb30]{padding:.15rem .4rem;background:rgba(1,1,1,.8);color:#fff;border-radius:3px;font-size:.31rem;display:table;margin:0 auto;line-height:.4rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7dbddb30","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/plugins/pl_message/template.vue
// module id = lWsf
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14